import { CONFIG } from '@/config/constants'

export function Footer() {
  const { STORE } = CONFIG

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* 店名 */}
          <div className="footer-brand">
            <img
              src="/assets/img/kamando_logo_alpha.png"
              alt="諫早パン工房Kamando"
              className="footer-logo"
            />
            <p>香ばしいかおりに包まれる、ちょっと贅沢な日常を</p>
          </div>

          {/* 店舗情報 */}
          <div className="footer-info">
            <h4>店舗情報</h4>
            <div className="footer-info-item">
              <i className="fas fa-map-marker-alt footer-icon"></i>
              <div>
                <p>〒854-0062</p>
                <p>長崎県諫早市小船越町９０６−７</p>
              </div>
            </div>
            <div className="footer-info-item">
              <i className="fas fa-phone footer-icon"></i>
              <p>
                <a href={`tel:${STORE.phone}`}>{STORE.phone}</a>
              </p>
            </div>
            <div className="footer-info-item">
              <i className="fas fa-clock footer-icon"></i>
              <div>
                <p>月〜金: 8:00-17:00</p>
                <p>土日祝: 8:00-18:00</p>
              </div>
            </div>
          </div>

          {/* メニュー */}
          <div className="footer-menu">
            <h4>メニュー</h4>
            <ul className="footer-nav-list">
              <li>
                <a href="#home">
                  <i className="fas fa-home"></i> トップ
                </a>
              </li>
              <li>
                <a href="#products">
                  <i className="fas fa-bread-slice"></i> 商品紹介
                </a>
              </li>
              <li>
                <a href="#blog-instagram">
                  <i className="fas fa-newspaper"></i> 新着情報
                </a>
              </li>
              <li>
                <a href="#concept">
                  <i className="fas fa-lightbulb"></i> コンセプト
                </a>
              </li>
              <li>
                <a href="#access">
                  <i className="fas fa-map-signs"></i> アクセス
                </a>
              </li>
            </ul>
          </div>

          {/* SNS */}
          <div className="footer-social">
            <h4>SNS</h4>
            <div className="footer-social-links">
              <a
                href={STORE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <i className="fab fa-instagram footer-icon"></i>Instagram
              </a>
            </div>
          </div>
        </div>

        {/* フッターボトム */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>
              &copy; 2025 諫早パン工房Kamando | 株式会社S&K. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
